export default __webpack_public_path__ + "static/media/instructions-end-of-round.fe55a411.png";